import cashU from './cashU.svg';
import credit7 from './credit7.svg';
import eKapusta from './eKapusta.svg';
import finspin from './finspin.svg';
import kredito24 from './kredito24.svg';
import mig from './mig.svg';
import nalichnie from './nalichnie.svg';
import platiza from './platiza.svg';
import vivus from './vivus.svg';
import webbankir from './webbankir.svg';

export const mfoIcons = {
  cashU,
  credit7,
  eKapusta,
  kredito24,
  mig,
  nalichnie,
  platiza,
  finspin,
  vivus,
  webbankir,
};
